module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epigraph",
    attrs: {
      "title": "Epigraph"
    }
  }, [_c('i', [_vm._v("“Now cracks a noble heart. Good night, sweet prince, and flights of angels sing thee to thy rest")]), _vm._v(".”"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM SHAKESPEARE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5387f000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_Epigraph.vue
// module id = 69
// module chunks = 0